module.exports = __webpack_public_path__ + "img/compensation-section-circle-arrow-v2.027ed07f.png";